import React, {cloneElement} from 'react'
import PropTypes from 'prop-types'
import ArrowRightIcon from '../icons/ArrowRightIcon'
import styles from './styles.css'

const iconProps = {
  size: 15,
  color: '#6674a6'
}

export default function InfoSection({icon, title, children, cerberId = ''}) {
  return (
    <section className={styles.root}>
      {icon && (
        <div className={styles.icon}>{cloneElement(icon, iconProps)}</div>
      )}
      <h4 data-cerber-id={cerberId}>
        {title}
        <ArrowRightIcon {...iconProps} />
      </h4>
      <div>{children}</div>
    </section>
  )
}

InfoSection.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  children: PropTypes.node,
  cerberId: PropTypes.string
}
